import { getVodStreams, getSeries } from "@/lib/xtream";
import { userKey } from "@/lib/store";

const cache = {};

export async function loadCatalog(creds) {
  const k = userKey(creds);
  if (cache[k]) return cache[k];
  const [movies, series] = await Promise.all([
    getVodStreams(creds).catch(() => []),
    getSeries(creds).catch(() => []),
  ]);
  cache[k] = {
    movies: Array.isArray(movies) ? movies : [],
    series: Array.isArray(series) ? series : [],
  };
  return cache[k];
}
